import { inject, InjectionKey, provide, Ref } from "vue";
type Panel = {
	width: Ref<number>;
	height: Ref<number>;
};

const PanelSymbol: InjectionKey<Panel> = Symbol();

export const providePanel = (panel: Panel) => {
	provide(PanelSymbol, panel);
};

export const usePanel = () => {
	const panel = inject(PanelSymbol);
	if (!panel) {
		throw new Error("Component must be child of PanelProject component");
	}

	return panel;
};
